module.exports = __webpack_public_path__ + "static/media/COVID-Icons_Hand.7014e60c.png";